module.exports = __webpack_public_path__ + "img/icon-x-mark.2598e795.png";